import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { ProviderIcon } from "@/components/ui/ProviderIcon";
import { usePayment } from "@/hooks/usePayment";
import * as shared from "@/styles/shared";
import { PaymentResultStatus } from "@shared/types/payment";
import { formatAddressProviderLabel, formatCurrency } from "@shared/utils";
import { CheckCircle2, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as paymentStyles from "./Payment.styles";
import * as styles from "./PaymentResults.styles";

const PaymentResults = () => {
  const { payResults } = usePayment();
  const { t } = useTranslation("invoices");

  if (!payResults?.length) return null;

  const successCount = payResults.filter((r) => r.success === PaymentResultStatus.SUCCESS).length;
  const failureCount = payResults.filter((r) => r.success === PaymentResultStatus.FAILURE).length;

  return (
    <Card variant="glass" className={styles.resultsContainer}>
      <CardHeader className={styles.resultsHeader}>
        <CardTitle className={styles.resultsTitle}>
          {successCount > 0 && (
            <span className={styles.successCount}>
              <CheckCircle2 className={shared.iconSm} />
              {successCount}
            </span>
          )}
          {failureCount > 0 && (
            <span className={styles.failureCount}>
              <XCircle className={shared.iconSm} />
              {failureCount}
            </span>
          )}
          {t("results", { ns: "invoices" })}
        </CardTitle>
      </CardHeader>
      <CardContent className={styles.resultsContent}>
        <div className={paymentStyles.resultsContainer}>
          {payResults.map((r) => (
            <div key={r.invoiceId} className={paymentStyles.row}>
              <div className={shared.flexTruncate}>
                <ProviderIcon provider={r.providerName} size="sm" />
                <span className={styles.resultsItemName}>{formatAddressProviderLabel(r.addressName, r.providerName)}</span>
              </div>
              <span className={paymentStyles.fontMonoWithMr3}>{formatCurrency(r.amount)}</span>
              {r.success === PaymentResultStatus.SUCCESS ? (
                <CheckCircle2 className={paymentStyles.successIcon} />
              ) : (
                <XCircle className={paymentStyles.errorIcon} />
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default PaymentResults;
